import { combineReducers } from 'redux';
import authReducer from './auth';
import vehicleInsturctionsReducer from './vehicleInsturctions';
import blog from './blog'
import questionnaire from './questionnaire';

export default combineReducers(
  Object.assign({
    auth: authReducer,
    vehicleInstruction: vehicleInsturctionsReducer,
    blog:blog,
    questionnaire: questionnaire,
  })
);





